export default "__VITE_ASSET__woFzLH_G__"